var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrandOutlookInverse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.78 2.78a2 2 0 0 0-2 2v14.44a2 2 0 0 0 2 2h14.44a2 2 0 0 0 2-2V4.78a2 2 0 0 0-2-2zm2.291 6.411q-.513 1.164-.513 2.878 0 2.679 1.477 4.21 1.478 1.523 3.98 1.523 2.472 0 3.95-1.531 1.476-1.538 1.477-4.256 0-2.74-1.493-4.278-1.485-1.539-3.964-1.538-1.37 0-2.419.443-.788.33-1.454 1.01a5.3 5.3 0 0 0-1.04 1.54zm2.702 5.694q-.88-.987-.88-2.893 0-1.935.857-2.893.857-.964 2.258-.964 1.4 0 2.242.949.85.95.85 2.878 0 1.95-.873 2.931-.864.972-2.22.972-1.353 0-2.234-.98",
  clipRule: "inherit"
})));
export { SvgBrandOutlookInverse as ReactComponent };